export default "__VITE_ASSET__D1n32ecC__"